import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from "i18next-http-backend";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(Backend)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru'],
    // lng: userLanguage,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      httpOnly: false,
      caches: ['cookie'],
      cookieSecure: true,      
      lookupCookie: 'i18next-lng',
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=75'
    }
  });

export default i18n;